import React from "react";
import "../../MainDashboard/mainDashboard.css";

export const SocialSecurityFormSkeleton = ({rows}) => {
  return (
    <div style={{marginTop:"1rem"}}>
      {/* Form Skeleton */}
      <div style={{ marginBottom: "2rem" }}>
        {/* Two-column rows for each input field */}
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              gap: "1rem",
              marginBottom: "1rem",
            }}
          >
            <div
              className="skeleton"
              style={{ width: "100%", height: "40px", borderRadius: "6px" }}
            ></div>
            <div
              className="skeleton"
              style={{ width: "100%", height: "40px", borderRadius: "6px" }}
            ></div>
          </div>
        ))}

        {/* Yes/No Buttons (two sets) */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <div
            className="skeleton"
            style={{ width: "60px", height: "35px", borderRadius: "6px" }}
          ></div>
          <div
            className="skeleton"
            style={{ width: "60px", height: "35px", borderRadius: "6px" }}
          ></div>
        </div>
        <div
          className="skeleton"
          style={{ width: "100%", height: "40px", borderRadius: "6px" }}
        ></div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            gap: "1rem",
            marginBottom: "1rem",
          }}
        >
          <div
            className="skeleton"
            style={{ width: "60px", height: "35px", borderRadius: "6px" }}
          ></div>
          <div
            className="skeleton"
            style={{ width: "60px", height: "35px", borderRadius: "6px" }}
          ></div>
        </div>
      </div>
    </div>
  );
};
